import * as arr from '@ant-design/icons-vue';

export function useIcons(vue) {
  Object.entries(arr).forEach(([key, value]) => {
    vue.component(key, value);
  });
}
